
export class Message {
private _text: string;
private _name: string;
constructor() {}
/**
 * @param {?} name
 * @return {?}
 */
public setName(name: string): void {
    this._name = name;
  }
/**
 * @return {?}
 */
public getName(): string {
    return this._name;
  }
/**
 * @param {?} text
 * @return {?}
 */
public setText(text: string): void {
    this._text = text;
  }
/**
 * @return {?}
 */
public getText(): string {
    return this._text;
  }
/**
 * @return {?}
 */
public toJson(): any {
    return {
      name: this._name,
      text: this._text
    }
  }
/**
 * @param {?} json
 * @return {?}
 */
public fromJson(json: any): void {
    if(!json)
      return;

    this._name = json.name;
    this._text = json.text;
  }
}

function Message_tsickle_Closure_declarations() {
/** @type {?} */
Message.prototype._text;
/** @type {?} */
Message.prototype._name;
}
